module.exports = __webpack_public_path__ + "img/check-green.5fcf09a4.png";